import {Notif} from "@/js/global/components/Notif";

/**
 * @var grecaptcha
 * @var localizedScript
 */
export const contactFormHandler = () => {
    const form = document.getElementById("contact_us_form");
    if (!form) return;

    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const name = form.querySelector("#user_name").value.trim();
        const company = form.querySelector("#user_company").value.trim();
        const subject = form.querySelector("#user_subject").value.trim();
        const email = form.querySelector("#user_email").value.trim();
        const message = form.querySelector("#user_message").value.trim();
        const nameError = form.querySelector("#user_name_error");
        const emailError = form.querySelector("#user_email_error");
        const messageError = form.querySelector("#user_message_error");
        const subjectError = form.querySelector("#user_subject_error");

        [nameError, emailError, subjectError, messageError].forEach(el => {
            el.textContent = ""; el.classList.add("hidden");
        });
        form.querySelectorAll(".form-input").forEach(el =>{
            el.classList.remove("border-error");
        });
        let valid = true;

        const nameLabel = document.querySelector('label[for="user_name"]');
        const emailLabel = document.querySelector('label[for="user_email"]');
        const subjectLabel = document.querySelector('label[for="user_subject"]');
        const messageLabel = document.querySelector('label[for="user_message"]');

		  if(company.length > 0){
			  valid = false;
              Notif.show('error','Spam');
		  }

        if (name.length < 2) {
            nameLabel.classList.add('label-error');
            nameError.textContent = "Please enter your name (min. 2 chars)";
            nameError.classList.remove("hidden");
            form.querySelector("#user_name").classList.add("border-error");
            valid = false;
        }else if (name.length > 200) {
            nameLabel.classList.add('label-error');
            nameError.textContent = "Text is too long (max. 200 chars)";
            nameError.classList.remove("hidden");
            form.querySelector("#user_name").classList.add("border-error");
            valid = false;
        }else{
            nameLabel.classList.remove('label-error');
            nameError.classList.add("hidden");
            form.querySelector("#user_name").classList.remove("border-error");
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            emailLabel.classList.add('label-error');
            emailError.textContent = "Not valid email";
            emailError.classList.remove("hidden");
            form.querySelector("#user_email").classList.add("border-error");
            valid = false;
        }else{
            emailLabel.classList.remove('label-error');
        }

        if (subject.length < 3) {
            subjectLabel.classList.add('label-error');
            subjectError.textContent = "Please enter your subject";
            subjectError.classList.remove("hidden");
            form.querySelector("#user_subject").classList.add("border-error");
            valid = false;
        }else if (subject.length > 100) {
            subjectLabel.classList.add('label-error');
            subjectError.textContent = "Text is too long (max. 200 chars)";
            subjectError.classList.remove("hidden");
            form.querySelector("#user_subject").classList.add("border-error");
            valid = false;
        }else{
            subjectLabel.classList.remove('label-error');
            subjectError.classList.add("hidden");
            form.querySelector("#user_subject").classList.remove("border-error");
        }

        const messageValue = message;
        if (messageValue.length > 0 && messageValue.length < 10) {
            messageLabel.classList.add('label-error');
            messageError.textContent = "Min. 10 chars";
            messageError.classList.remove("hidden");
            form.querySelector("#user_message").classList.add("border-error");
            valid = false;
        } else if (messageValue.length > 0 && messageValue.length > 1000) {
            messageLabel.classList.add('label-error');
            messageError.textContent = "Max.: 1000 chars";
            messageError.classList.remove("hidden");
            form.querySelector("#user_message").classList.add("border-error");
            valid = false;
        }else{
            messageLabel.classList.remove('label-error');
        }

        if (!valid) return;

        const pk = localizedScript.pk;
        const nonce = localizedScript.contact_us_form_nonce;
        const action = localizedScript.contact_us_form_action;


        try {
            const token = await grecaptcha.execute(pk, { action: action });

            const formData = new FormData();
            formData.append("action", action);
            formData.append("name", name);
            formData.append("company", company);
            formData.append("email", email);
            formData.append("subject", subject);
            formData.append("message", message);
            formData.append("nonce", nonce);
            formData.append("recaptcha_token", token);

            const res = await fetch(localizedScript.ajax_url, {
                method: "POST",
                body: formData,
            });

            const result = await res.json();
            console.log(result);
            if (result.success === false) {
                Notif.show('error',result?.data?.message);
                return;
            }

            form.reset();
            Notif.show('success',result?.data?.message);
        } catch (error) {
            console.log(error);
            Notif.show('error','Connecting error. Try again latter');
        }
    });
};